import authService from "utils/auth";
import { Navigate } from "react-router-dom";
import { storage } from "utils/storage";
import NotAuthorized from "components/ui/NotAuthorized";

type PrivateRouteProps = {
  element: React.FC;
  allowedRoles: Array<string>;
};

const PrivateRoute = ({ element: Component, allowedRoles, ...rest }: PrivateRouteProps) => {
  const user = storage.getUserFromStorage();

  if (!allowedRoles.includes(user?.role)) {
    return <NotAuthorized />;
  }

  return authService.isLogin() ? <Component {...rest} /> : <Navigate to="/" />;
};

export default PrivateRoute;
